import { Id } from "@dgs/core";
import { TenantOptionResource } from "../../../../shared/types/tenant";
import { ApplicationContactStatusResource } from "../types/application";
import { AddressType, AddressUpdateResource } from "./address";
import { ContactAttribute, ContactAttributeValue } from "./contactAttribute";
import { IContactCompanyOptionResource, IContactCompanyUpdateResource } from "./contactCompany";
import { ContactEmailType, IContactEmailUpdateResource } from "./contactEmail";
import { ContactPhoneType, IContactPhoneUpdateResource } from "./contactPhone";
import { TagOptionResource } from "./tag";

export interface ContactCheckEmailResource {
	id: Id;
	contactEmailState: "LINK_TO_ARCHIVE" | "IS_ONLY_ON_OTHER_TENANTS" | "LINK_TO_LIST";
}

export interface IContactIndexResource {
	id: Id;
	attributes: ContactAttribute[];
}

export interface IEventContactIndexResource extends IContactIndexResource {
	cost: number;
	status: string | null;
	numberOfClippings: number;
}

export interface ClippingProviderContactResource {
	id: Id;
	name: string;
	primaryCompany: IContactCompanyOptionResource | null;
	numberOfClippings: number;
}

export interface IEventClippingsResource {
	numberOfClippings: number;
}

export interface IAddEventContactsRequest {
	contactIds: Id[];
}

export interface IEventUpdateCostRequest {
	cost: number;
}

export interface IEventUpdateStatusRequest {
	status: string | null;
}

export type IContactUpdateResource = {
	id: Id;
	firstName: string;
	lastName: string;
	email: string | null;
	affiliatedEventCount: number;
	lastAppLogin: string | null;
	affiliatedCarFleetCount: number;
	newsletters: ApplicationContactStatusResource[];
	contactEmails: IContactEmailUpdateResource[];
	contactPhones: IContactPhoneUpdateResource[];
	addresses: AddressUpdateResource[];
	companies: IContactCompanyUpdateResource[];
	locale: string;
	tenants: TenantOptionResource[];
	attributes: ContactAttribute[];
	tags: TagOptionResource[];
	archivedByTenants: TenantOptionResource[];
	isArchived: boolean;
	hasUser: boolean;
};

export type IContactOptionResource = {
	id: Id;
	firstName: string;
	lastName: string;
	email: string | null;
};

export type IContactUpdateRequest = {
	attributes: ContactAttributeValue[];
};

export type IContactUpdateFormState = {
	attributes: ContactAttribute[];
};

export type IContactBaseInfoFormState = {
	locale: string;
	tenants: TenantOptionResource[];
};

export type IContactBaseInfoRequest = {
	locale: string;
	tenantIds: Id[];
};

export interface ContactEventIndexResource {
	id: Id;
	name: string;
	start: string;
	end: string;
	isArchived: boolean;
	cost: number;
	status: string | null;
	numberOfClippings: number;
}

export type ContactStatus = "PARTICIPATION" | "NO_RESPONSE" | "NO_SHOW" | "DECLINED" | "DECLINED_WITH_REPLACEMENT";
export const allContactStatus: ContactStatus[] = [
	"PARTICIPATION",
	"NO_RESPONSE",
	"NO_SHOW",
	"DECLINED",
	"DECLINED_WITH_REPLACEMENT",
];

export interface ContactCreateMasterDataRequest {
	contactTypeId: Id;
	firstName: string;
	lastName: string;
	primaryEmail: string;
	primaryEmailType: ContactEmailType;
	primaryPhoneNumber: string;
	primaryPhoneNumberType: ContactPhoneType;
	tagIds: Id[];
	tenantIds: Id[];
	locale: string;
}

export interface ContactCreateDetailsRequest {
	dataFieldId: Id;
	value: unknown;
}

export interface ContactCreateCompanyRequest {
	companyId: Id;
	position: string;
	isPrimary: boolean;
	isEvent: boolean;
	isCarFleet: boolean;
}

export interface ContactCreateAddressRequest {
	city: string;
	zip: string;
	houseNumber: string;
	street: string;
	additionalInfo: string;
	type: AddressType;
	countryId: Id;
	isPrimary: boolean;
}

export interface ContactCreateAdditionalEmailRequest {
	email: string;
	type: ContactEmailType;
}

export interface ContactCreateAdditionalPhoneNumberRequest {
	phoneNumber: string;
	type: ContactPhoneType;
}

export interface ContactCreateRequest {
	masterData: ContactCreateMasterDataRequest;
	details: ContactCreateDetailsRequest[];
	companies: ContactCreateCompanyRequest[];
	addresses: ContactCreateAddressRequest[];
	additionalEmails: ContactCreateAdditionalEmailRequest[];
	additionalPhoneNumbers: ContactCreateAdditionalPhoneNumberRequest[];
}
